import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import QRCode from "qrcode.react";
import axios from "../../services/axios";
import RSelect from "react-select";
import ReactLoading from "react-loading";
import { CopyToClipboard } from "react-copy-to-clipboard";
import isConsultant from "../../services/isConsultant";

function QrCode() {
  const consultancyName = localStorage.getItem("consultant.name");
  const [cceBitly, setCceBitly] = useState({});
  const [formTemplate, setFormTemplate] = useState([]);
  const [singleFormDetails, setSingleFormDetails] = useState({});
  const [values, setValues] = useState("");
  const [status, setStatus] = useState(false);
  const [copied, setCopied] = useState(false);
  const [showScanner, setShowScanner] = useState(false);

  const userId = localStorage.getItem("consultant.id");

  // CCE_Form_Internal
  // bitly link: - rb.gy/bsmdzd
  const qrValue = `https://dh.maxicus.com/validatemobile/${singleFormDetails?.value}?formname=${singleFormDetails?.label}&source=Consultant&consultant_name=${consultancyName}&utm_medium=&utm_campaign=&utm_term=`;

  const downloadQRCode = () => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `${qrValue}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  //  bitlytoken:-  af61fd464ab0339d57daf9e19ac4b65399027d43
  const handleShorten = async (link) => {
    try {
      const apiKey = "af61fd464ab0339d57daf9e19ac4b65399027d43";
      const response = await fetch(`https://api-ssl.bitly.com/v4/shorten`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiKey}`,
        },
        body: JSON.stringify({ long_url: qrValue }),
      });
      const json = await response.json();
      setCceBitly(json);
      (await json?.id) !== undefined && setStatus(false);
      //   return json.link;
    } catch (error) {
      console.error(error);
      setStatus(false);
    }
  };

  // async function fetchForm(){
  //    await axios.get(`/formtemplate`)
  //     .then(res => {
  //         setFormTemplate(res?.data)
  //     })
  // }

  async function consultantFormId() {
    await axios
      .get(`/registerConsultant/singleconsultant/${userId}`)
      .then((res) => {
        setFormTemplate(res?.data?.formId);
      });
  }

  useEffect(() => {
    // handleShorten()
    // fetchForm()
    consultantFormId();
  }, [singleFormDetails, userId]);

  const handleClick = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <Dashboard>
      {status && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <h1>Scanner code</h1>
      {isConsultant() && (
        <div className="row">
          {/* //react select */}
          <div className="col-md-4 col-sm-12">
            <div className="card p-3">
              <label className="ml-2">
                <b>Select Form</b>
              </label>
              <RSelect
                value={formTemplate.map((ele) => {
                  if (ele._id === values) {
                    return {
                      label: ele?.label,
                      value: ele.value,
                    };
                  }
                })}
                options={formTemplate.map((trf) => {
                  return {
                    label: trf?.label,
                    value: trf.value,
                  };
                })}
                onChange={(e) => {
                  setValues(e.value);
                  setSingleFormDetails(e);
                  setShowScanner(true);
                  // setStatus(true)
                }}
              ></RSelect>
            </div>
          </div>

          {showScanner && (
            <div className="col-md-8 col-sm-12">
              <div className="card p-3 d-flex align-items-center justify-content-center flex-column">
                <h1 className="ml-3">
                  {singleFormDetails?.label !== undefined
                    ? singleFormDetails?.label
                    : "DUMMY QR-CODE"}
                </h1>
                <QRCode
                  id="qr-gen"
                  value={qrValue}
                  size={290}
                  level={"H"}
                  includeMargin={true}
                />
                <h4 className="ml-1">
                  {/* <a href={cceBitly.link} target="_blank" >{cceBitly.id}</a> */}
                  {/* <button className="btn btn-primary ml-2"
                    onClick={() =>  navigator.clipboard.writeText(qrValue)}
                    >
                    Copy Link
                </button> */}
                  <CopyToClipboard text={qrValue}>
                    <button
                      onClick={handleClick}
                      className="btn btn-primary ml-2"
                    >
                      Copy Link
                    </button>
                  </CopyToClipboard>

                  <button
                    className="btn btn-primary ml-1"
                    onClick={downloadQRCode}
                  >
                    Download QR Code
                  </button>
                  {copied ? (
                    <span style={{ color: "green" }}>Copied.</span>
                  ) : null}
                </h4>
              </div>
            </div>
          )}
        </div>
      )}
    </Dashboard>
  );
}

export default QrCode;
